var _path, _path2, _path3, _path4, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillInTheBlanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.071 175C58.6482 175 25.0708 141.423 25.0708 100C25.0708 58.5774 58.6482 25 100.071 25C141.493 25 175.071 58.5774 175.071 100C175.071 141.423 141.493 175 100.071 175Z",
    fill: "url(#paint0_linear_26801_789)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6001 52C38.6001 48.6863 41.2864 46 44.6001 46H132.6C135.914 46 138.6 48.6863 138.6 52V140C138.6 143.314 135.914 146 132.6 146H44.6001C41.2864 146 38.6001 143.314 38.6001 140V52Z",
    fill: "url(#paint1_linear_26801_789)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6001 62C76.0478 62 75.6001 62.4477 75.6001 63V64.5C75.6001 65.0523 75.1524 65.5 74.6001 65.5C74.0478 65.5 73.6001 65.0523 73.6001 64.5V63C73.6001 61.3431 74.9432 60 76.6001 60H78.6626C79.2149 60 79.6626 60.4477 79.6626 61C79.6626 61.5523 79.2149 62 78.6626 62H76.6001ZM81.7876 61C81.7876 60.4477 82.2353 60 82.7876 60H86.9126C87.4649 60 87.9126 60.4477 87.9126 61C87.9126 61.5523 87.4649 62 86.9126 62H82.7876C82.2353 62 81.7876 61.5523 81.7876 61ZM90.0376 61C90.0376 60.4477 90.4853 60 91.0376 60H95.1626C95.7149 60 96.1626 60.4477 96.1626 61C96.1626 61.5523 95.7149 62 95.1626 62H91.0376C90.4853 62 90.0376 61.5523 90.0376 61ZM98.2876 61C98.2876 60.4477 98.7353 60 99.2876 60H103.413C103.965 60 104.413 60.4477 104.413 61C104.413 61.5523 103.965 62 103.413 62H99.2876C98.7353 62 98.2876 61.5523 98.2876 61ZM106.538 61C106.538 60.4477 106.985 60 107.538 60H109.6C111.257 60 112.6 61.3431 112.6 63V64.5C112.6 65.0523 112.152 65.5 111.6 65.5C111.048 65.5 110.6 65.0523 110.6 64.5V63C110.6 62.4477 110.152 62 109.6 62H107.538C106.985 62 106.538 61.5523 106.538 61ZM74.6001 66.5C75.1524 66.5 75.6001 66.9477 75.6001 67.5V69C75.6001 69.5523 76.0478 70 76.6001 70H78.6626C79.2149 70 79.6626 70.4477 79.6626 71C79.6626 71.5523 79.2149 72 78.6626 72H76.6001C74.9432 72 73.6001 70.6569 73.6001 69V67.5C73.6001 66.9477 74.0478 66.5 74.6001 66.5ZM111.6 66.5C112.152 66.5 112.6 66.9477 112.6 67.5V69C112.6 70.6569 111.257 72 109.6 72H107.538C106.985 72 106.538 71.5523 106.538 71C106.538 70.4477 106.985 70 107.538 70H109.6C110.152 70 110.6 69.5523 110.6 69V67.5C110.6 66.9477 111.048 66.5 111.6 66.5ZM81.7876 71C81.7876 70.4477 82.2353 70 82.7876 70H86.9126C87.4649 70 87.9126 70.4477 87.9126 71C87.9126 71.5523 87.4649 72 86.9126 72H82.7876C82.2353 72 81.7876 71.5523 81.7876 71ZM90.0376 71C90.0376 70.4477 90.4853 70 91.0376 70H95.1626C95.7149 70 96.1626 70.4477 96.1626 71C96.1626 71.5523 95.7149 72 95.1626 72H91.0376C90.4853 72 90.0376 71.5523 90.0376 71ZM98.2876 71C98.2876 70.4477 98.7353 70 99.2876 70H103.413C103.965 70 104.413 70.4477 104.413 71C104.413 71.5523 103.965 72 103.413 72H99.2876C98.7353 72 98.2876 71.5523 98.2876 71Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6001 104C48.0478 104 47.6001 104.448 47.6001 105V106.75C47.6001 107.302 47.1524 107.75 46.6001 107.75C46.0478 107.75 45.6001 107.302 45.6001 106.75V105C45.6001 103.343 46.9432 102 48.6001 102H50.2668C50.819 102 51.2668 102.448 51.2668 103C51.2668 103.552 50.819 104 50.2668 104H48.6001ZM52.6001 103C52.6001 102.448 53.0478 102 53.6001 102H56.9334C57.4857 102 57.9334 102.448 57.9334 103C57.9334 103.552 57.4857 104 56.9334 104H53.6001C53.0478 104 52.6001 103.552 52.6001 103ZM59.2668 103C59.2668 102.448 59.7145 102 60.2668 102H63.6001C64.1524 102 64.6001 102.448 64.6001 103C64.6001 103.552 64.1524 104 63.6001 104H60.2668C59.7145 104 59.2668 103.552 59.2668 103ZM65.9334 103C65.9334 102.448 66.3811 102 66.9334 102H68.6001C70.257 102 71.6001 103.343 71.6001 105V106.75C71.6001 107.302 71.1524 107.75 70.6001 107.75C70.0478 107.75 69.6001 107.302 69.6001 106.75V105C69.6001 104.448 69.1524 104 68.6001 104H66.9334C66.3811 104 65.9334 103.552 65.9334 103ZM46.6001 109.25C47.1524 109.25 47.6001 109.698 47.6001 110.25V112C47.6001 112.552 48.0478 113 48.6001 113H50.2668C50.819 113 51.2668 113.448 51.2668 114C51.2668 114.552 50.819 115 50.2668 115H48.6001C46.9432 115 45.6001 113.657 45.6001 112V110.25C45.6001 109.698 46.0478 109.25 46.6001 109.25ZM70.6001 109.25C71.1524 109.25 71.6001 109.698 71.6001 110.25V112C71.6001 113.657 70.257 115 68.6001 115H66.9334C66.3811 115 65.9334 114.552 65.9334 114C65.9334 113.448 66.3811 113 66.9334 113H68.6001C69.1524 113 69.6001 112.552 69.6001 112V110.25C69.6001 109.698 70.0478 109.25 70.6001 109.25ZM52.6001 114C52.6001 113.448 53.0478 113 53.6001 113H56.9334C57.4857 113 57.9334 113.448 57.9334 114C57.9334 114.552 57.4857 115 56.9334 115H53.6001C53.0478 115 52.6001 114.552 52.6001 114ZM59.2668 114C59.2668 113.448 59.7145 113 60.2668 113H63.6001C64.1524 113 64.6001 113.448 64.6001 114C64.6001 114.552 64.1524 115 63.6001 115H60.2668C59.7145 115 59.2668 114.552 59.2668 114Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9334 62.4832C46.9334 60.8263 48.2766 59.4832 49.9334 59.4832H67.2667C68.9236 59.4832 70.2667 60.8263 70.2667 62.4832V68.8427C70.2667 70.4996 68.9236 71.8427 67.2667 71.8427H49.9334C48.2766 71.8427 46.9334 70.4996 46.9334 68.8427V62.4832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6001 105C74.6001 103.343 75.9432 102 77.6001 102H102.6C104.257 102 105.6 103.343 105.6 105V112C105.6 113.657 104.257 115 102.6 115H77.6001C75.9432 115 74.6001 113.657 74.6001 112V105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9334 83.8315C46.9334 82.1746 48.2766 80.8315 49.9334 80.8315H91.4334C93.0903 80.8315 94.4334 82.1746 94.4334 83.8315V90.191C94.4334 91.8479 93.0903 93.191 91.4334 93.191H49.9334C48.2766 93.191 46.9334 91.8479 46.9334 90.191V83.8315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.1 62.4832C116.1 60.8263 117.443 59.4832 119.1 59.4832H127.267C128.924 59.4832 130.267 60.8263 130.267 62.4832V68.8427C130.267 70.4996 128.924 71.8427 127.267 71.8427H119.1C117.443 71.8427 116.1 70.4996 116.1 68.8427V62.4832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7668 83.8315C97.7668 82.1746 99.1099 80.8315 100.767 80.8315H127.267C128.924 80.8315 130.267 82.1746 130.267 83.8315V90.191C130.267 91.8479 128.924 93.191 127.267 93.191H100.767C99.1099 93.191 97.7668 91.8479 97.7668 90.191V83.8315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6001 127C46.6001 125.343 47.9432 124 49.6001 124H80.6001C82.257 124 83.6001 125.343 83.6001 127V133C83.6001 134.657 82.257 136 80.6001 136H49.6001C47.9432 136 46.6001 134.657 46.6001 133V127Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26801_789)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_26801_789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.069 145.373L89.2711 150.973C88.873 151.106 88.4942 150.727 88.6269 150.329L94.2263 133.53C94.4763 132.78 94.8976 132.099 95.4565 131.54L145.505 81.4914C147.494 79.5026 150.718 79.5026 152.707 81.4914L158.108 86.8928C160.097 88.8817 160.097 92.1059 158.108 94.0948L108.06 144.143C107.501 144.702 106.819 145.123 106.069 145.373Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.506 97.6952L141.903 85.0921L136.747 90.2484L149.35 102.852L154.506 97.6952Z",
    fill: "url(#paint2_linear_26801_789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.005 102.198L137.402 89.5948L95.5073 131.49L108.11 144.093L150.005 102.198Z",
    fill: "url(#paint3_linear_26801_789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1695 142.701L88.6271 150.329C88.4944 150.727 88.8731 151.106 89.2714 150.973L96.8986 148.431L91.1695 142.701Z",
    fill: "url(#paint4_linear_26801_789)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_789",
    x: 46.6001,
    y: 58.4832,
    width: 83.6667,
    height: 77.5168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_789"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_789"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_789",
    result: "effect2_innerShadow_26801_789"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_26801_789",
    x: 87.5999,
    y: 77.9998,
    width: 72,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.611765 0 0 0 0 0.905882 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_789",
    x1: 25.0708,
    y1: 36.7188,
    x2: 168.039,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_789",
    x1: 88.6001,
    y1: 46,
    x2: 88.6001,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_789",
    x1: 141.5,
    y1: 85.4949,
    x2: 136.995,
    y2: 97.4029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_789",
    x1: 138.781,
    y1: 90.9733,
    x2: 154.665,
    y2: 114.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_789",
    x1: 88.6001,
    y1: 143.35,
    x2: 96.5096,
    y2: 150.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26801_789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white",
    transform: "translate(88.6001 80)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillInTheBlanks);
export default __webpack_public_path__ + "static/media/Fill-in-the-Blanks.d12cb88fd42333d61d0554f316ccd193.svg";
export { ForwardRef as ReactComponent };